/* eslint-disable */
import React from "react";
import { MdEmail, MdOutlineLaptopChromebook } from "react-icons/md";
import { ImPhone, ImMobile, ImLaptop } from "react-icons/im";
import { BsFillGeoAltFill } from "react-icons/bs";

import * as Styles from "./styles";

interface PermissoesProps {
  idPermissao: string;
  chave: string;
}

interface LocaisProps {
  idLocal: string;
  nome: string;
}

interface EmpreendimentosProps {
  idEmpreendimento: string;
  nome: string;
}

interface UserData {
  acessoAdmin: boolean;
  acessoMobile: boolean;
  ativo: true;
  celular: string | null;
  email: string;
  id: string;
  idCorretor: string;
  idPerfilCorretor: string;
  idRegional: string;
  nome: string;
  nomeFotoUsuario: string;
  nomePerfilAcesso: string;
  nomeRegional: string;
  siglaNome: string;
  empreendimentos: EmpreendimentosProps[];
  locais: LocaisProps[];
  permissoes: PermissoesProps[];
}

interface Props {
  data: UserData;
}

const ProfileCard: React.FC<Props> = ({ data }) => {
  const formatPhoneNumber = (str: string) => {
    str = str.replace(/[^\d]/g, ""); //remove all non digits
    return str.replace(/(\d{2})(\d{5})(\d{4})/, "($1)$2-$3");
  };
  return (
    <Styles.Container>
      {data?.nomeFotoUsuario?.length <= 77 ? (
        <Styles.UserIcon />
      ) : (
        <Styles.Image src={data?.nomeFotoUsuario} />
      )}
      <Styles.Content>
        <Styles.RowAlign>
          <Styles.Title>{data?.nome}</Styles.Title>
          {data.siglaNome ? (
            <Styles.SiglaBadge>
              <Styles.SiglaText>{data?.siglaNome}</Styles.SiglaText>
            </Styles.SiglaBadge>
          ) : null}
        </Styles.RowAlign>

        <Styles.SpaceY space={4} />
        <Styles.LightText>{data?.nomePerfilAcesso}</Styles.LightText>
        <Styles.SpaceY space={16} />
        <Styles.Row>
          <Styles.Column>
            <Styles.RowAlign>
              <MdEmail />
              <Styles.SpaceX space={8} />
              <Styles.LightText>{data?.email}</Styles.LightText>
            </Styles.RowAlign>
            <Styles.SpaceY space={8} />
            <Styles.RowAlign>
              <BsFillGeoAltFill />
              <Styles.SpaceX space={8} />
              <Styles.LightText>
                {data.nomeRegional ? data?.nomeRegional : "Sem regional"}
              </Styles.LightText>
            </Styles.RowAlign>
          </Styles.Column>
          <Styles.SpaceX space={32} />
          <Styles.Column>
            <Styles.RowAlign>
              <ImPhone />
              <Styles.SpaceX space={8} />
              <Styles.LightText>
                {data.celular
                  ? formatPhoneNumber(data?.celular)
                  : "Não informado"}
              </Styles.LightText>
            </Styles.RowAlign>
            <Styles.SpaceY space={7} />
            <Styles.RowAlign>
              <Styles.TypeText>Acesso: </Styles.TypeText>
              {data.acessoMobile && (
                <>
                  <Styles.SpaceX space={8} />
                  <ImMobile />
                </>
              )}
              {data.acessoAdmin && (
                <>
                  <Styles.SpaceX space={8} />
                  <ImLaptop />
                </>
              )}
            </Styles.RowAlign>
          </Styles.Column>
        </Styles.Row>
      </Styles.Content>
    </Styles.Container>
  );
};

export default ProfileCard;
